import { Button } from "@/components/ui/button";
import { DialogRoot, DialogHeader, DialogFooter } from "@/components/ui/dialog";

const FOUNDER_CALL_LINK =
  "https://calendly.com/dylantorpey/reveshare-discovery-call";

interface FounderCallModalProps {
  isOpen: boolean;
  onBookCall: () => void;
  onMaybeLater: () => void;
}

export function FounderCallModal({
  isOpen,
  onBookCall,
  onMaybeLater,
}: FounderCallModalProps) {
  return (
    <DialogRoot
      open={isOpen}
      onOpenChange={(open) => !open && onMaybeLater()}
      panelClassName="max-w-xl"
    >
      <DialogHeader
        showCloseButton
        onClose={onMaybeLater}
        className="mb-0 gap-4 border-b border-border px-6 py-4"
      >
        New to Reveshare? We can help you set it up
      </DialogHeader>

      <p className="px-6 py-5 text-sm text-muted-foreground">
        Book a free 45-minute call with Dylan Torpey, one of our founders, to
        get your affiliate program up and running.
      </p>

      <DialogFooter className="mt-0 border-t border-border px-6 py-4">
        <Button variant="outline" onClick={onMaybeLater}>
          Maybe later
        </Button>
        <Button asChild>
          <a
            href={FOUNDER_CALL_LINK}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onBookCall}
          >
            Book a call
          </a>
        </Button>
      </DialogFooter>
    </DialogRoot>
  );
}
